import React from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, IconButton, Divider, Typography } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import CloseIcon from '@mui/icons-material/Close';

const FileUpload = ({ selectedFiles, handleRemoveFile, getRootProps, getInputProps, isDragActive }) => {
  return (
    <Box sx={{mt:5}}>
      <Typography sx={{ fontSize: '0.8rem', pb: 1 }}>
      Attachments (PDF, Image, CSV), Identity, Payslip, Tax, rental history etc.
      </Typography>
      <Box
        {...getRootProps()}
        sx={{
          background:"#F9F9F9",
          border: "2px dashed #dbd6d6",
          padding: "20px",
          textAlign: "center",
          cursor: "pointer",
          borderRadius: 2,
          ...(isDragActive ? { backgroundColor: "#f0f0f0" } : {}),
        }}
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <BackupOutlinedIcon sx={{ fontSize: 40, color: '#9B98E7' }} />
            <Typography>Drop the files here...</Typography>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <BackupOutlinedIcon sx={{ fontSize: 40, color: '#9B98E7' }} />
            <Typography  variant="body1"sx={{ color: '#6e6d7a' }} >Attachments (PDF, Image, CSV), Identity, Payslip, Tax, rental history etc.</Typography>
          </Box>
        )}
      </Box>
      <List style={{ maxHeight: '100px', overflowY: 'auto' }}>
        {selectedFiles.map((file, index) => (
          <React.Fragment key={index}>
            <ListItem>
              <ListItemIcon>
                <InsertDriveFileIcon />
              </ListItemIcon>
              <ListItemText primary={<Typography sx={{ fontSize: '0.8rem' }}>{file.name}</Typography>} />
              <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveFile(index)}>
                <CloseIcon sx={{ fontSize: '1rem' }} />
              </IconButton>
            </ListItem>
            <Divider />
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default FileUpload;
